import React, { useEffect, useState, useRef } from 'react';
import { FaBook } from 'react-icons/fa';
import { GiRuleBook } from 'react-icons/gi';
import './rules.css'; // Import the CSS file
import JoditEditor from 'jodit-react'; // Import JoditEditor
import { Form, Button, Alert } from 'react-bootstrap'; // Import Bootstrap components
import { FaEdit } from "react-icons/fa";
import axios from 'axios';

const Rules = () => {
    const [rules, setRules] = useState(''); // State to handle the editor content
    const [error, setError] = useState(''); // State to handle error messages
    const [success, setSuccess] = useState(''); // State to handle success messages
    const editor = useRef(null); // Use ref to access editor instance
    const config = {
        readonly: false, // Allow editing
        height: 400, // Set height of the editor
    };

    // Fetch rules data on component mount
    useEffect(() => {
        const fetchRules = async () => {
            try {
                const response = await axios.get('https://backend.ems.hiradentallab.com/api/rules/'); // Adjust the URL according to your server setup
                setRules(response.data.content); // Set the content in state
            } catch (error) {
                console.error('Error fetching rules:', error);
                setError('Failed to fetch rules data.');
                setTimeout(() => setError(''), 3000); // Clear error after 3 seconds
            }
        };
        fetchRules();
    }, []);

    // Handle form submission for updating rules
    const handleUpdate = async (e) => {
        e.preventDefault(); // Prevent default form submission
        try {
            await axios.put('https://backend.ems.hiradentallab.com/api/rules/', { content: rules }); // Send updated content
            setSuccess('Rules updated successfully!');
            setError('');
            setTimeout(() => setSuccess(''), 3000); // Clear success message after 3 seconds
        } catch (error) {
            console.error('Error updating rules:', error);
            setError('Error updating rules.');
            setSuccess('');
            setTimeout(() => setError(''), 3000); // Clear error after 3 seconds
        }
    };

    return (
        <div className='container-fluid'>
            <div>
                <h1 className='rules-title'>
                    <FaBook /> Rules
                </h1>
                <hr />
                <h1 className='rules-subtitle'>
                    <GiRuleBook style={{ marginRight: '8px' }} /> HIRA DENTAL LAB Rules
                </h1>
                <hr />
            </div>
            <div className='rules-content'>
                {error && <Alert variant='danger'>{error}</Alert>}
                {success && <Alert variant='success'>{success}</Alert>}
                <Form onSubmit={handleUpdate}>
                    <div className="mb-3">
                        <Form.Label htmlFor="rulesEditor" className="form-label">
                            Rules:
                        </Form.Label>
                        <JoditEditor
                            ref={editor}
                            value={rules}
                            config={config}
                            tabIndex={1} // tabIndex of textarea
                            onBlur={newContent => setRules(newContent)} // Update state on blur
                            className="editor" // Added class for styling
                        />
                    </div>
                    <div className="form-actions">
                    <Button type='submit' variant='primary'>
                        <FaEdit /> Update Rules
                    </Button>
                    </div>
                </Form>
            </div>
        </div>
    );
};

export default Rules;
